<template> 
  <div class="look-top" @mousedown="getReady">
            <div class="fl" style="width:50px; line-height:70px;">年</div> 
            <div style="width: 86px; float: left;">
                    <p class="div1" :class="ye.list.year == date ?' seled':' '" v-for="(ye,ind) in yearDatas" @click="sh1(ind,ye.list.year)">{{ye.list.year}}</p>
            </div>
            <div class="fl" style="width:50px; line-height:70px;">月</div>
            <div id="xuanz" style="float: left;width:80%;overflow: hidden;height:80px;">
                    <p class="fileDiv"  :class="mo.type?' seled':' '" v-for="(mo,ind) in monthDatas" @click="sh(ind)">{{mo.list.MONTH_DISP}}</p>
            </div>
  </div>
</template>

<script>
export default {
    name: 'calendar',
    props:['yearData','quarterData'],
    data() {
        return {
            timeValue: '',
            timeValue1:'',
            timeSh:true,
            isday:false,
            teheadList: ['日', '一', '二', '三', '四', '五', '六'], 
            year: '',
            month: 0,
            dty:7,
            // daysssz: this.timeList,
            tbodyList: [],
            currentDay: '',
            today:'',
            startTime:'',
            endTime: '',
            // timeList:[],
            yearDatas:[],
            quarterDatas:this.quarterData,
            monthDatas:[],
            monthData:[],
            selList:[],
            selListAll:[],
            date:[], 
            dateDatasList:[],
        }
    },
    mounted() {
        let self = this; 
          //  self.getReady();
    },
    created(){ 
           let self = this; 
           self.getDateYear();
          //  setTimeout(function(){
              
          //  },1500)
    },
    beforeMount(){ 
           let self = this;   
    },

    watch: {  
    },
    methods: {
        getDateYear(){
            let self = this; 
            self.date = [];
            self.monthDataOld = [];
            self.monthDatas = [];
            self.yearDatas = [];
            self.dateDatasList = [];
            self.$emit('getResult',self.dateDatasList);
            self.dimensionZoneTopList = JSON.parse(localStorage.getItem("dimensionZoneTopList"));
            if(self.dimensionZoneTopList != null && self.dimensionZoneTopList.length > 0){
                self.dimensionZoneTopList.forEach((i)=>{
                  if(i.dimensionName == '年'){ 
                      if(i.resultList != null && i.resultList.length > 0){
                        i.resultList.forEach((j)=>{
                            let item = {
                                list:j,
                                type:false,
                                dimensionGuid:i.dimensionGuid
                            }
                            self.yearDatas.push(item);
                            console.log(self.yearDatas);
                        })
                      }
                    }else if(i.dimensionName == '月'){
                      if(i.resultList != null && i.resultList.length > 0){
                        i.resultList.forEach((j)=>{
                            let item = {
                                list:j,
                                type:false
                            }
                            self.monthDatas.push(item);
                            self.monthDataOld.push(item);
                        })
                      }
                    }
                    if(i.dimensionLinkageVOS != null && i.dimensionLinkageVOS.length > 0){
                      i.dimensionLinkageVOS.forEach((h)=>{
                        if(self.yearDatas != null && self.yearDatas.length > 0){
                            self.yearDatas.forEach((j)=>{
                              if(h.linkageDimensionGuid == j.dimensionGuid){ 
                                  j.getOnclick = true;        
                              }else{
                                  j.getOnclick = false;
                              }
                            })
                        }
                              
                      })
                    }
                })
            }
            console.log(self.yearDatas);
        },
        sh1(ind,date){
            this.dateDatasList = [];
            this.date = date;
            this.monthDatas.forEach((i)=>{
              i.type = false;
            })
            
            this.dateDatasList.push(this.yearDatas[ind].list); 
            if(this.yearDatas[ind].getOnclick){ 
                    this.getFilter(this.yearDatas[ind].list.year);
                    this.$emit('getResult',this.dateDatasList);
            }
            
            // this.$emit('getResult',this.yearData[index].date);
            // this.$emit('getYearmonths'); 刷新年月
        },
        getFilter(year){  
          this.monthDatas = [];
          if(this.monthDataOld != null && this.monthDataOld.length > 0){
            this.monthDataOld.forEach((i)=>{
              if(i.list.year == year){

                this.monthDatas.push(i);
              }
            })
          }
          // this.monthDatas.list = this.monthDatas.list.filter(obj => obj.MONTH.split('年')[0] === year);
        }, 
        sh2(index){
            // var id = document.getElementById(index);  
            if(this.quarterData[index].type){
                this.quarterData[index].type = false;
            }else{
                this.quarterData[index].type = true;
            } 
        },
        sh(index){
            // var id = document.getElementById(index);  
            if(this.monthDatas[index].type){
                this.monthDatas[index].type = false;
            }else{
                this.monthDatas[index].type = true;
            } 
            this.monthDatas.forEach((i)=>{
              if(i.type){
                if(this.dateDatasList.indexOf(i.list)==-1){
                  this.dateDatasList.push(i.list);
                }  
              }else{
                this.dateDatasList.forEach((j,index)=>{
                  if(i.list == j){
                      this.dateDatasList.splice(index,1);
                  }
                }) 
              }
            })
            console.log(this.dateDatasList);
            this.$emit('getResult',this.dateDatasList);
        },
        getReady(){
            let self = this;
                    // document.ondblclick = function() {   
                    // document.onmousedown = function() {   
                        self.selList = []; 
                        var fileNodes = document.getElementsByTagName("p");   
                        for ( var i = 0; i < fileNodes.length; i++) {  
                          if (fileNodes[i].className.indexOf("fileDiv") != -1) {  
                            // fileNodes[i].className = "fileDiv";  
                            self.selList.push(fileNodes[i]);   
                          }  
                        }
                        // self.selListAll = self.selList; 
                        var isSelect = true;  
                        var evt = window.event || arguments[0];  
                        var startX = (evt.x || evt.clientX);  
                        var startY = (evt.y || evt.clientY);  
                        var selDiv = document.createElement("p");  
                        selDiv.style.cssText = "position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;filter:alpha(opacity:60);opacity:0.6;display:none;";  
                        selDiv.id = "selectDiv";   
                        document.getElementById("xuanz").appendChild(selDiv);  
                        // document.body.appendChild(selDiv);  
                        selDiv.style.left = startX + "px";  
                        selDiv.style.top = startY + "px";  
                        var _x = null;  
                        var _y = null;  
                        self.clearEventBubble(evt);  
                        document.onmousemove = function() {  
                          // document.onmouseover = function() {  
                          evt = window.event || arguments[0];  
                          if (isSelect) {  
                            if (selDiv.style.display == "none") {  
                              selDiv.style.display = "";  
                            }  
                            _x = (evt.x || evt.clientX);  
                            _y = (evt.y || evt.clientY);  
                            selDiv.style.left = Math.min(_x, startX) + "px";  
                            selDiv.style.top = Math.min(_y, startY) + "px";  
                            selDiv.style.width = Math.abs(_x - startX) + "px";  
                            selDiv.style.height = Math.abs(_y - startY) + "px"; 

                            // ---------------- 关键算法 ---------------------  

                            var _l = selDiv.offsetLeft, _t = selDiv.offsetTop;  
                            var _w = selDiv.offsetWidth, _h = selDiv.offsetHeight;  
                            for ( var i = 0; i < self.selList.length; i++) {  
                              var sl = self.selList[i].offsetWidth + self.selList[i].offsetLeft;  
                              var st = self.selList[i].offsetHeight + self.selList[i].offsetTop;  
                              if (sl > _l && st > _t && self.selList[i].offsetLeft < _l + _w && self.selList[i].offsetTop < _t + _h) {  
                                if (self.selList[i].className.indexOf("seled") == -1) {  
                                  self.selList[i].className = self.selList[i].className + " seled";  
                                }  
                              } else {  
                                if (self.selList[i].className.indexOf("seled") != -1) {  
                                  // self.selList[i].className = "fileDiv";  
                                }  
                              }  
                            }  
                          }  
                          self.clearEventBubble(evt);  
                        }  
                        document.onmouseup = function() {  
                          isSelect = false;  
                          if (selDiv) {  
                            // document.body.removeChild(selDiv);  
                            document.getElementById("xuanz").removeChild(selDiv);  
                            self.showSelDiv(self.selList);  
                          }  
                          self.selList = null, _x = null, _y = null, selDiv = null, startX = null, startY = null, evt = null;
                        }  
                      // }
        }, 
                    clearEventBubble(evt) {  
                      if (evt.stopPropagation)  
                        evt.stopPropagation();  
                      else  
                        evt.cancelBubble = true;  
                      if (evt.preventDefault)  
                        evt.preventDefault();  
                      else  
                        evt.returnValue = false;  
                    },  
                    showSelDiv(arr) {   
                      var selInfo = [];  
                      let self = this;
                      console.log(arr);
                      if(arr !=null && arr.length >0){
                        for ( var i = 0; i < arr.length; i++) {  
                            if (arr[i].className.indexOf("seled") != -1) {   
                              selInfo.push(arr[i].innerHTML);  
                            }  
                          }  
                          // console.log('sss',selInfo); 
                          self.monthDatas.forEach((i)=>{
                                selInfo.forEach((j)=>{
                                    if(i.list.MONTH_DISP == j ){ 
                                        if(self.monthDatas.length == selInfo.length){
                                          if(i.type){
                                            i.type = false;
                                          }else{
                                            i.type = true;
                                          }
                                        }else{
                                          i.type = true; 
                                        } 
                                    }
                                })    
                          })  
                          self.dateDatasList = []; 
                          self.monthDatas.forEach((j)=>{
                            if(j.type){
                              if(self.dateDatasList.indexOf(j.list)==-1){
                                self.dateDatasList.push(j.list);
                              }  
                            }
                          })
                          self.$emit('getResult',self.dateDatasList);
                      }
                      
                    } 
    }
}
</script>

<style scoped>
/*body{padding:100px;} */
p {
  margin: 0;
}
.look-top{padding-top: 20px;}
.div1{float:left;width:86px;height:28px;text-align:center;line-height:28px;font-size:14px;border:1px solid #ccc;margin-right:5px;margin-bottom:10px;cursor: pointer; border-radius: 2px;} 
.div2{float:left;width:86px;height:28px;text-align:center;line-height:28px;font-size:14px;border:1px solid #ccc;margin-right:5px;margin-bottom:10px;cursor: pointer; border-radius: 2px;} 
.fileDiv{float:left;width:86px;height:28px;text-align:center;line-height:28px;font-size:14px;border:1px solid #ccc;margin-right:10px;margin-bottom:10px;cursor: pointer; border-radius: 2px;background: #ffffff;} 
.seled{border:1px solid #649fa3; color:#649fa3;  background-color:rgba(116,197,203,0.2);} 
h3{text-align: center;padding-bottom: 50px}
    
</style>